<template>
    <div class="title mt-4">
        <div :class="{
                'input-focus-effect': true,
                'rv-valiadate-input-form': error
            }">
            <input :class="title != '' ? 'border-primary' : ''" type="text" id="inputTitle"
                v-model="title" @focus="$emit('update:error', '')"/>
            <label :class="{
                    'mb-0': true,
                    'input-on-alue': title != ''
                }">Tiêu đề</label>
        </div>
        <div class="text-danger fs-12px mt-1" v-if="error">{{error}}</div>
    </div>
</template>
<script>
export default {
    props: ['data', 'error'],
    data() {
        return {
            title: ''
        }
    },
    watch: {
        data(val){
            this.title = val;
        },
        title(val){
            this.$emit('update:data', val);
        }
    },
    created() {
        this.title = this.data;
    }
}
</script>
